import $ from 'jquery';
import select2 from 'select2';

$(document).on('turbo:load', () => {
  const $scholarshipForm = $('.registration-form');

  if ( $scholarshipForm.length ) {
    select2($);
    const $selectBoxes = $scholarshipForm.find('select');

    if ( $selectBoxes.data('select2-id') ) {
      $selectBoxes.select2('destroy');
    }

    $selectBoxes.select2({ minimumResultsForSearch: -1 });

    $scholarshipForm.on('change', '.registration-form-birthday select', () => {
      const month = $scholarshipForm.find('select.registration-form-birthday-month').val();
      const day   = $scholarshipForm.find('select.registration-form-birthday-day').val();
      const year  = $scholarshipForm.find('select.registration-form-birthday-year').val();

      $scholarshipForm
        .find('input[type="hidden"].registration-form-birthday-date')
        .val(`${ month }-${ day }-${ year }`);
    });
  }
});

$(document).on('turbo:before-cache', () => {
  const $scholarshipForm = $('.registration-form');

  if ( $scholarshipForm.length ) {
    select2($);
    $scholarshipForm.find('select').select2('destroy');
  }
});
